$(document).ready(function() {
  var $lista = $("#product-grid");
  var $elementosLi = $lista.find("li");
  
  if ($elementosLi.length > 7) {
      var $divNuevo = $(
        '<li class="grid__item imagen-collection-page">' +
          '<a href="/pages/how-to-experts-mezuzah">' +
            '<video autoplay playsinline loop muted src="https://cdn.shopify.com/videos/c/o/v/c67b10234f984790a11a8980472af6f2.mp4"></video>' + 
            '<div class="overlay">'+
              '<h4>How to choose</h4>' +
              '<p>the perfect Mezuzah</p>'+
              '<span>Know More</span>' +
            '</div>' +
          '</a>' +
        '</li>'
      );
      $elementosLi.eq(5).after($divNuevo);
  } else {
      var $divNuevo = $(
        '<li class="grid__item imagen-collection-page">' +
          '<a href="/pages/how-to-experts-mezuzah">' +
            '<video autoplay playsinline loop muted src="https://cdn.shopify.com/videos/c/o/v/c67b10234f984790a11a8980472af6f2.mp4"></video>' + 
            '<div class="overlay">'+
              '<h4>How to choose</h4>' +
              '<p>the perfect Mezuzah</p>'+
              '<span>Know More</span>' +
            '</div>' +
          '</a>' +
        '</li>'
      );
      $elementosLi.eq(1).after($divNuevo);
  };
});